module.exports = __webpack_public_path__ + "static/media/temp_26.fe343981.jpg";